module.exports = __webpack_public_path__ + "static/media/edit.f44f787d.svg";